<template>
  <div v-if="show" class="loading-container">
    <div class="loading-mask"></div>
    <div class="loading-content">
      <div class="sk-three-bounce">
        <div class="sk-child sk-bounce1"></div>
        <div class="sk-child sk-bounce2"></div>
        <div class="sk-child sk-bounce3"></div>
      </div>
<!--      <div class="loading-text">{{ text }}</div>-->
    </div>
  </div>
</template>
<script>
export default {
  name: 'Loading',
  props: {
    show: Boolean
  },
  // data() {
  //   return {
  //     text: '正在加载...'
  //   }
  // }
}
</script>
<style lang="scss" scoped>
.loading-container{
  position: relative;
  text-align: center;
  .loading-mask{
    position: fixed;
    top:0;
    bottom:0;
    left:0;
    right:0;
    background-color:rgba(0,0,0,.75);
    z-index: 9000;
  }
  .loading-content{
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 10000;
    transform: translate(-50%,-45%);
    text-align: center;
    color:#fff;

    //.loading-text{
    //  font-size: 14px;
    //  color: #fff;
    //}
  }
}




//.spinner {
//  width: 40px;
//  height: 40px;
//  position: relative;
//  text-align: center;
//
//  -webkit-animation: sk-rotate 1.5s infinite linear;
//  animation: sk-rotate 1.5s infinite linear;
//}

.sk-three-bounce {
  margin: 0;
  width: 100%;
  height: 100%;
  text-align: center;
}

.sk-three-bounce .sk-child {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 12px;
  margin-left: 6px;
  background-color: #c8dcfb;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-three-bounce 1s ease-in-out 0s infinite both;
  animation: sk-three-bounce 1s ease-in-out 0s infinite both
}

.sk-three-bounce .sk-bounce1 {
  -webkit-animation-delay: -0.2s;
  animation-delay: -0.2s
}

.sk-three-bounce .sk-bounce2 {
  -webkit-animation-delay: -0.1s;
  animation-delay: -0.1s
}

@-webkit-keyframes sk-three-bounce {

  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0)
  }

  40% {
    -webkit-transform: scale(1);
    transform: scale(1)
  }
}

@keyframes sk-three-bounce {

  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0)
  }

  40% {
    -webkit-transform: scale(1);
    transform: scale(1)
  }
}
</style>